{
  "tabs": {
    "chat": "Chat",
    "reminders": "Påminnelser",
    "calendar": "Kalender",
    "settings": "Innstillinger"
  },
  "common": {
    "cancel": "Avbryt",
    "save": "Lagre",
    "confirm": "Bekreft",
    "delete": "Slett",
    "back": "Tilbake",
    "close": "Lukk",
    "edit": "Rediger",
    "search": "Søk",
    "all": "Alle",
    "loading": "Laster...",
    "error": "Noe gikk galt",
    "notFound": "Ikke funnet",
    "tryAgain": "Vennligst prøv igjen",
    "retry": "Prøv igjen",
    "undo": "Angre",
    "pullToRefresh": "Dra for å oppdatere",
    "justNow": "akkurat nå"
  },
  "auth": {
    "welcome": "Velkommen til FishMemory",
    "tagline": "Din WhatsApp-påminnelsesassistent, nå i lomma di.",
    "subtitle": "Din WhatsApp-påminnelsesassistent, nå i lomma di.",
    "phoneLabel": "Ditt WhatsApp-nummer",
    "phoneHint": "Vi sender en verifiseringskode via WhatsApp",
    "invalidPhone": "Vennligst oppgi et gyldig telefonnummer",
    "continue": "Fortsett",
    "enterPhone": "Skriv inn ditt WhatsApp-nummer",
    "phonePlaceholder": "Telefonnummer",
    "sendCode": "Send kode",
    "verifyTitle": "Bekreft nummeret ditt",
    "otpSentTo": "En 6-sifret kode ble sendt til {{phone}} via WhatsApp",
    "enterFullCode": "Vennligst skriv inn alle 6 sifrene",
    "invalidOtp": "Ugyldig kode. Vennligst prøv igjen.",
    "otpFailed": "Kunne ikke sende kode. Prøv igjen.",
    "otpResent": "Kode sendt på nytt",
    "resendIn": "Send på nytt om {{seconds}}s",
    "resendCode": "Send kode på nytt",
    "enterOtp": "Skriv inn koden sendt til WhatsApp",
    "verify": "Bekreft",
    "resend": "Send kode på nytt",
    "wrongNumber": "Feil nummer?",
    "backToPhone": "Tilbake til telefon",
    "editPhone": "Endre telefonnummer",
    "error": "Feil",
    "setupTitle": "La oss sette opp",
    "setupSubtitle": "Du kan alltid endre dette senere i Innstillinger",
    "namePlaceholder": "Ditt navn",
    "letsGo": "Fullfør oppsett",
    "skipForNow": "Hopp over for nå"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Skriv en melding...",
    "inputPlaceholder": "Skriv en melding...",
    "typing": "FishMemory skriver...",
    "online": "På nett",
    "connecting": "Kobler til...",
    "reconnecting": "Kobler til igjen...",
    "offline": "Frakoblet",
    "empty": "Start en samtale",
    "emptyHint": "Lag påminnelser, sjekk timeplanen eller be om hjelp.",
    "emptyAction": "Send en eksempelpåminnelse",
    "actions": "Chat-handlinger",
    "keep": "Behold meldinger",
    "clearTitle": "Tøm chat",
    "clearConfirm": "Slett alle meldinger på denne enheten? Dette kan ikke angres.",
    "clear": "Tøm chat",
    "optionSelected": "Valgt: {{label}}",
    "sendingSelection": "Sender...",
    "connectionLost": "Kobler til igjen..."
  },
  "reminders": {
    "title": "Mine påminnelser",
    "active": "Aktive",
    "today": "I dag",
    "thisWeek": "Denne uken",
    "history": "Historikk",
    "items": "elementer",
    "emptyTitle": "Ingen påminnelser ennå",
    "emptySubtitle": "Lag en fra chatten, så vises den her.",
    "emptyAction": "Åpne chat",
    "filterActive": "Aktive",
    "filterToday": "I dag",
    "filterWeek": "Denne uken",
    "filterHistory": "Historikk",
    "emptyState": "Ingen påminnelser ennå. Start en chat!",
    "swipeDone": "Ferdig",
    "swipeSnooze": "Utsett",
    "swipeDelete": "Slett",
    "search": "Søk påminnelser...",
    "upcoming": "Kommende",
    "completed": "Fullført",
    "overdue": "Forsinket",
    "tomorrow": "I morgen",
    "synced": "Synkronisert {{value}}",
    "swipeHint": "Sveip en påminnelse for flere handlinger",
    "noResults": "Ingen påminnelser matcher søket",
    "noResultsHint": "Prøv et annet søkeord eller fjern søket",
    "deleteAllFailed": "Kunne ikke slette alle påminnelser"
  },
  "calendar": {
    "title": "Kalender",
    "today": "I dag",
    "tomorrow": "I morgen",
    "completed": "ferdig",
    "noEvents": "Ingen planlagte hendelser",
    "noEventsSubtitle": "Velg en dato for å se påminnelser og kalenderhendelser.",
    "googleEvent": "Google Kalender",
    "legendActive": "Aktiv",
    "legendRecurring": "Gjentakende",
    "legendDone": "Ferdig",
    "legendGoogle": "Google",
    "previousMonth": "Forrige måned",
    "nextMonth": "Neste måned",
    "previousYear": "Forrige år",
    "nextYear": "Neste år",
    "goToToday": "Gå til i dag",
    "all": "Alle",
    "active": "Aktive",
    "done": "Ferdige",
    "paused": "Pause"
  },
  "settings": {
    "title": "Innstillinger",
    "profile": "Profil",
    "name": "Visningsnavn",
    "enterName": "Skriv inn navnet ditt",
    "language": "Språk",
    "uiLanguage": "App-språk",
    "uiLanguageHelp": "Endrer appens grensesnitt, kalenderetiketter og layoutretning på denne enheten.",
    "serverLanguage": "Chatspråk",
    "serverLanguageHelp": "Endrer språket som brukes i serverens svar og påminnelsesmeldinger for kontoen din.",
    "timezone": "Tidssone",
    "currentTimezone": "Nåværende tidssone",
    "timezoneHelp": "Alle påminnelsestider vises i denne tidssonen.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Lagre tidssone",
    "timezoneSaved": "Tidssone oppdatert",
    "detect": "Oppdag",
    "detectFailed": "Kunne ikke oppdage tidssone",
    "autoDetect": "Auto-oppdag fra GPS",
    "notifications": "Varsler",
    "notificationsHelp": "Oppfølgingspåminnelser styrer gjentatte varsler etter at en påminnelse er levert. Varseltillatelser styres fortsatt i telefonens innstillinger.",
    "pushEnabled": "Push-varsler",
    "autoDoneOnFire": "Marker automatisk som ferdig ved varsling",
    "autoDoneOnFireDesc": "Når av, forblir påminnelser aktive til du markerer dem som ferdige.",
    "googleCalendar": "Google Kalender",
    "google": "Google Kalender",
    "googleConnected": "Tilkoblet",
    "googleDisconnected": "Ikke tilkoblet",
    "googleConnectedHelp": "Nye påminnelser kan synkroniseres automatisk til kalenderen din.",
    "googleDisconnectedHelp": "Koble til Google Kalender for å holde påminnelser og hendelser synkronisert.",
    "googleConnectFailed": "Kunne ikke koble til Google Kalender",
    "connected": "Tilkoblet",
    "disconnected": "Ikke tilkoblet",
    "connect": "Koble til",
    "disconnect": "Koble fra",
    "autoSync": "Autosynkroniser nye påminnelser",
    "autosync": "Autosynkroniser nye påminnelser",
    "subscription": "Abonnement",
    "trialUsed": "Prøveperiode: {{used}}/{{total}} brukt",
    "trialStatus": "Prøveperiode tilgjengelig",
    "activeStatus": "Aktivt abonnement",
    "expiredStatus": "Abonnement utløpt",
    "unsubscribedStatus": "Ikke abonnert",
    "about": "Om",
    "version": "Versjon",
    "logout": "Logg ut",
    "logoutTitle": "Logg ut",
    "logoutConfirm": "Er du sikker på at du vil logge ut?",
    "noName": "Ingen navn satt",
    "serverConnection": "Servertilkobling",
    "serverUrl": "Server-URL",
    "serverEdit": "Rediger",
    "saveReconnect": "Lagre og koble til igjen",
    "resetDefault": "Tilbakestill standard",
    "invalidServerUrlTitle": "Ugyldig server-URL",
    "invalidServerUrlMessage": "Skriv inn en gyldig http- eller https-server-URL, for eksempel https://example.com",
    "uiLanguageChangeFailed": "Kunne ikke endre app-språk. Vennligst prøv igjen.",
    "serverLanguageChangeFailed": "Kunne ikke endre chatspråk. Vennligst prøv igjen.",
    "timezoneChangeFailed": "Kunne ikke endre tidssone. Vennligst prøv igjen.",
    "autoSyncChangeFailed": "Kunne ikke oppdatere autosynkronisering. Vennligst prøv igjen.",
    "nameChangeFailed": "Kunne ikke oppdatere visningsnavn. Vennligst prøv igjen.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Påminnelsesdetaljer",
    "editTime": "Endre tid",
    "rename": "Gi nytt navn",
    "snooze": "Utsett",
    "snooze15": "Utsett 15 minutter",
    "pause": "Pause",
    "pauseReminder": "Pause påminnelse",
    "resume": "Fortsett",
    "resumeReminder": "Fortsett påminnelse",
    "skip": "Hopp over neste",
    "skipOccurrence": "Hopp over denne forekomsten",
    "syncGoogle": "Synkroniser til Google",
    "delete": "Slett",
    "deleteTitle": "Slett påminnelse",
    "deleteConfirm": "Denne påminnelsen vil bli slettet permanent.",
    "deleteRecurringTitle": "Slett gjentakende påminnelse",
    "deleteRecurringMessage": "Vil du hoppe over denne forekomsten eller slette hele serien?",
    "deleteThisOccurrence": "Hopp over denne forekomsten",
    "deleteEntireSeries": "Slett hele serien",
    "done": "Ferdig",
    "markDone": "Marker som ferdig",
    "undo": "Gjenopprett",
    "undoPrompt": "Trenger du den aktiv igjen? Gjenopprett nå.",
    "recurring": "Gjentakende",
    "nextRun": "Neste kjøring",
    "oneTime": "Engangs",
    "pending": "Avventer",
    "sent": "Sendt",
    "paused": "Pauset",
    "active": "Aktiv",
    "snoozed": "Utsatt",
    "localTime": "Vises i din lokale tid",
    "recurrence": "Gjentakelse",
    "created": "Opprettet",
    "tags": "Tagger",
    "fireCount": "Antall ganger utløst",
    "actions": "Handlinger",
    "none": "Ingen",
    "snoozeFailed": "Kunne ikke utsette påminnelse",
    "pauseFailed": "Kunne ikke pause påminnelse",
    "resumeFailed": "Kunne ikke fortsette påminnelse",
    "skipFailed": "Kunne ikke hoppe over påminnelse",
    "doneFailed": "Kunne ikke markere påminnelse som ferdig",
    "undoFailed": "Kunne ikke gjenopprette påminnelsesstatus",
    "deleteFailed": "Kunne ikke slette påminnelse",
    "rescheduleTitle": "Endre tidspunkt?",
    "rescheduleMsg": "Denne påminnelsen er forsinket. Vil du endre tidspunkt?",
    "reschedule15": "Om 15 minutter",
    "reschedule60": "Om 1 time",
    "keepOverdue": "Behold som den er"
  },
  "onboarding": {
    "slide1Title": "Velkommen til FishMemory",
    "slide1Sub": "Din personlige påminnelsesassistent — drevet av WhatsApp og laget for lomma di.",
    "slide2Title": "Bare chat naturlig",
    "slide2Sub": "Skriv påminnelser slik du tenker: \"Minne meg på å ringe mamma i morgen kl 15\" — vi ordner resten.",
    "slide3Title": "Gå aldri glipp av noe",
    "slide3Sub": "Få tidsriktige varsler, organiser med tagger, og hold oversikt over alt som betyr noe.",
    "getStarted": "Kom i gang",
    "next": "Neste",
    "firstReminderTitle": "Lag din første påminnelse!",
    "firstReminderHint": "Prøv å skrive noe som:",
    "firstReminderExample": "Minne meg på å drikke vann i morgen kl 09",
    "gotIt": "Skjønner!",
    "notifRationaleTitle": "Hold deg presis",
    "notifRationaleBody": "FishMemory trenger varsler for å minne deg til rett tid. Du får bare varsler for påminnelser du lager.",
    "notifRationaleAllow": "Aktiver varsler",
    "notifRationaleLater": "Kanskje senere",
    "swipeHint": "Sveip til høyre for raske handlinger →",
    "calendarDragHint": "Dra for å utvide ↕"
  }
}
